import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../stores/actionsList';

import HttpServices from '../utils/Http.services'
import { checkTranslation, translate } from '../utils/useful'
import { actionsData } from '../variables/actionsData'
import ButtonAnimated from './buttons/ButtonAnimated'
import SwitchInput from './inputs/SwitchInput'
import FormViewer from './FormViewer'

class SideActionsList extends Component {
    state = {
        actionList: [],
        data: {},
        headers: [
            // { key: 'type', type: 'SelectInput', col: '12', information: {label: 'Action type', placeholder: 'Choose...',  type: "local", items: [{ title: 'view', value: 'View' }, { title: 'edit', value: 'edit' }, { title: 'view history', value: 'viewHistory' }, { title: 'remove', value: 'remove' }, { title: 'share', value: 'share' }, { title: 'change stage', value: 'changeStage' }, { title: 'next stage', value: 'nextStage' }, { title: 'send to', value: 'sendTo' }, { title: 'send as mail', value: 'sendAsMail' }, { title: 'request approval', value: 'requestApproval' }, { title: 'download as pdf', value: 'downloadAsPdf' }, { title: 'share', value: 'share' }, { title: 'open window', value: 'openWindow' }], required: true } },
            { key: 'name', type: 'TextInput', col: '12', information: { label: 'Action Name', placeholder: 'Name to be used in the list', required: true } },

            { key: 'type', type: 'SelectInput', col: '12', information: { label: 'Action type', placeholder: 'Choose...', type: "local", items: [{ title: 'Run automation', value: 'runAutomation' }, { title: 'Show page', value: 'showPage' }, { title: 'Open page', value: 'openWindow' }, { title: 'View history', value: 'viewHistory' }, { title: 'Change stage', value: 'changeStage' }, { title: 'Next stage', value: 'nextStage' }, { title: 'Last stage', value: 'lastStage' }, { title: 'Change stage to ...', value: 'changeStageTo' }, { title: 'Send to', value: 'sendTo' }, { title: 'Send as ...', value: 'sendAs' }, { title: 'Request approval', value: 'requestApproval' }, { title: 'Download as pdf', value: 'downloadAsPdf' }, { title: 'Share', value: 'share' },], required: true } },


            {
                key: 'runAutomation', type: 'SelectInput', col: '12', information: { label: '{{lang}}Run Automation', type: 'api', address: 'getAutomations', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, required: true }, disabled: true,
                dependencies: [{
                    refKey: 'type', targetKey: 'runAutomation',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'runAutomation' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    // show:true,

                }]
            },
            {
                key: 'trigger', type: 'SelectInput', col: '12', information: { label: '{{lang}}flow', type: 'api', address: 'getAutomationTriggers', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: 'key' }, required: true }, disabled: true,
                dependencies: [{
                    refKey: 'runAutomation', targetKey: 'trigger',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.runAutomation' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.filter._id', value: '@data.runAutomation' }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    init: true,
                    // show:true,

                }]
            },






            {
                key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}Page', type: 'api', address: 'getFrames', filter: { type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Page', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'type', targetKey: 'page',
                    conditions: [{
                        root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'showPage' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    init: true,
                    // show:true,

                }]

            },




            {
                key: 'pageParams',  type: 'PageParamsInput', col: '12', information: { label: '{{lang}}Page params', placeholder: '{{lang}}fileds', required: false },
                dependencies: [{
                    refKey: ['type', 'page'], targetKey: 'pageParams',
                    conditions: [{
                        root: { id: 'root', action: 'or', conditions: { 3: { id: 3, source: { value: '@data.page' }, operator: { value: '!=' }, target: { value: null } },1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'showPage' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.frame', value: '@data.page' }] }
                    }],
                    else: { show: false },
                    init: true,

                }],
            },


            {
                key: 'recipients', type: 'TextInput', col: '12', information: { label: '{{lang}}Recipients', placeholder: '{{lang}}Recipients', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'type', targetKey: 'recipients',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'sendAsMail' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    init: true,
                    // show:true,

                }]

            },
            {
                key: 'subject', type: 'TextInput', col: '12', information: { label: '{{lang}}Subject', placeholder: '{{lang}}Subject', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'type', targetKey: 'subject',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'sendAsMail' } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,
                    // show:true,

                }]

            },
            {
                key: 'body', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}Body', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'type', targetKey: 'body',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'sendAsMail' } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                    }],
                    else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                    init: true,
                    // show:true,

                }]

            },
            {
                key: 'attachments', type: 'FileInput', col: '12', information: { label: '{{lang}}Attachments', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'type', targetKey: 'attachments',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'sendAsMail' } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,
                    // show:true,

                }]
            },


            { key: 'hasCondition', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available just in specific conditions', hint: 'If you want the action to always be available, do not use this option.', default: false, required: false } },

            {
                key: 'condition', type: 'FilterEditorInput', col: '12', information: { label: 'Availablity condition', placeholder: 'Choose...', type: "local", items: [], required: false },
                dependencies: [{
                    refKey: 'hasCondition', targetKey: 'condition',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.hasCondition' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,
                    // show:true,

                }]
            },

            { key: 'reusable', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Can be used in other frames', hint: 'If you turn on the option, this action can be used by other frames of this applet. Permissions will be considered for each frame individually.', default: false, required: false } },


        ]
    }
    componentDidMount = () => {
        this.init()
    }
    init = () => {
        let actionList = this.props.page?.actions ? JSON.parse(JSON.stringify(this.props.page?.actions)) : []
        this.setState({ actionList })
    }
    changeValue = (key, value, extra) => {
        let actionList = this.state.actionList
        if (value) {
            actionList.push(key)
        }
        else {
            let aIndex = actionList.indexOf(key)
            actionList.splice(aIndex, 1)
        }
        this.setState({ actionList })
    }

    submitActions = () => {
        if (this.form.getForm()) {
            this.setState({ isLoadingData: true })
            let body = {}
            let page = this.props.page
            // body.page = page.key
            for (const [key, value] of Object.entries(body)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
            // console.log('page', this.props)
            body.frame = page?._id
            body.applet = this.props.variables.appletId
            body.actions = this.form.getForm()

            // console.log("postFrameActions",body)

            HttpServices.request('postFrameActions', body, (fetchResult, fetchError) => {
                this.setState({ isLoadingData: false })
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }
                if (fetchResult.info) {
                    page.actions = fetchResult.info.actions
                    this.props.setData('page', page, 'BaseAdminView')
                }
                if (fetchResult.applet) {
                    this.props.setData('applet.actions', fetchResult.applet.actions, 'Applet')

                }

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
                this.props.changeSidebar('frameActions', 'close')
            })
        }
    }
    render() {
        // console.log(this.props.params)
        return (
            <div className='w-100'>
                <div className='px-3 py-1 w-100 flexcb mb-3' style={{ borderBottom: '1px solid #eee' }}>
                    <p className='text-semibold'>{translate("Create custom action")}</p>
                    <div className="flexc mrd-2">
                        <ButtonAnimated
                            iconwidth='24px'
                            icon='/assets/icons/plus-white.svg'
                            onClick={() => { this.submitActions() }}
                            isLoading={this.state.isLoadingData}
                            title={translate('Create')}
                            textColor={'#fff'}
                            bg={this.props.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
                            width={'100%'}
                        />
                    </div>
                </div>
                {/* {console.log(';;', this.props)} */}
                <FormViewer ref={el => this.form = el} headers={this.state?.headers} formClass="bordered-form" inputClass={'bordered-input'} params={this.props.params} variables={this.props.variables} />
                {/* {Object.values(actionsData).map((element, index) => {
                    return (

                        <div className='px-3 py-2 flexc'>
                            <div className='w-100 flexcb'>
                                <p>{checkTranslation(element.label)}</p>
                                <SwitchInput data={this.state.actionList?.includes(element.key)} header={{ key: element.key, information: { size: 'small', } }} changeValue={this.changeValue} extra={{ type: 'admin', index: index }} />
                            </div>
                        </div>
                    )
                })} */}
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(SideActionsList);